<template>
  <div
    class="intent-item pa-0 mb-3"
    :style="{
      border: `1px solid ${$vuetify.theme.primary}`,
      'border-left': intentStatus.isOnline ? `5px solid #a0e83d` : `5px solid red`
    }"
    :class="{ edit: isEdit }"
    v-if="intent"
  >
    <v-layout wrap v-if="!isEdit" @click="toggleDetail">
      <v-flex xs12 sm8>
        <div v-if="!isEdit" class="text-truncate pa-2">
          <template v-if="!hideStatus">
            <toggle-button
              v-if="!livechat"
              :value="intent.intentstatus"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="onChangeIntentStatus"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </template>
          {{ intentLabel(intent.intentname) }}
        </div>
      </v-flex>

      <v-flex xs12 sm4 class="text-xs-right pa-1">
        <div style="display: inline-block" @click.stop>
          <template v-if="isCommentToInbox && !isLiveStream">
            <v-chip label outline small disabled color="info">
              <IntentSelectPostLabel v-model="postidlist"></IntentSelectPostLabel>
            </v-chip>

            <div class="clearfix" style="margin-bottom: 10px"></div>
          </template>
          <template v-if="selectedBot.theme == 'universalutilities' && !livechat">
            <template
              v-if="intent.intentgroup == selectedBot.uu_areaname || !selectedBot.uu_areaname"
            >
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="!isEdit"
                @click="isEdit = true"
              >
                <em class="fas fa-pencil-alt" />
              </v-btn>
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="
                  !isEdit &&
                  intent.intentname != '{default}' &&
                  intent.intentname != '{default_comment_to_inbox}' &&
                  !hideCopy
                "
                @click="onCopyMyIntent()"
              >
                <em class="fa fa-copy middle" />
              </v-btn>
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="
                  !isEdit &&
                  intent.intentname != '{default}' &&
                  intent.intentname != '{default_comment_to_inbox}' &&
                  !hideDelete
                "
                @click="$emit('onDelete')"
              >
                <em class="fa fa-trash middle" />
              </v-btn>
            </template>
          </template>
          <template v-else-if="!livechat">
            <template
              v-if="
                ['{default_comment_to_inbox}'].includes(intent.intentname) &&
                $store.getters.getPackage != 'premium' &&
                selectedBot.pagetype != 'enterprise'
              "
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="extra-small ma-1" readonly fab outline small color="grey" v-on="on">
                    <v-icon>lock</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Upgrade to Premium Plan') }}</span>
              </v-tooltip>
            </template>
            <template v-else>
              <template v-if="['dentalhub'].includes(selectedBot.type)">
                <v-btn
                  :color="intent.is_favorite ? '#ffd700' : 'primary'"
                  :outline="!intent.is_favorite"
                  :dark="!intent.is_favorite"
                  @click="handleSetFavorite"
                  small
                >
                  <em class="fas fa-star"></em>
                  <span class="pl-2">รายการโปรด</span>
                </v-btn>
              </template>
              <v-btn
                fab
                outline
                color="primary"
                class="extra-small ma-1"
                v-if="!isEdit"
                @click="editIntent"
              >
                <em class="fas fa-pencil-alt" />
              </v-btn>
            </template>

            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              v-if="
                !isEdit &&
                intent.intentname != '{default}' &&
                !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname) &&
                !hideCopy
              "
              @click="onCopyMyIntent()"
            >
              <em class="fa fa-copy middle" />
            </v-btn>
            <v-btn
              fab
              outline
              color="primary"
              class="extra-small ma-1"
              v-if="
                !isEdit &&
                intent.intentname != '{default}' &&
                !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname) &&
                !hideDelete
              "
              @click="$emit('onDelete')"
            >
              <em class="fa fa-trash middle" />
            </v-btn>
          </template>
          <template v-else-if="livechat">
            <div style="position: relative; min-height: 84px">
              <template v-if="['dentalhub'].includes(selectedBot.type)">
                <v-btn
                  :color="intent.is_favorite ? '#ffd700' : 'primary'"
                  :outline="!intent.is_favorite"
                  :dark="!intent.is_favorite"
                  @click="handleSetFavorite"
                  small
                >
                  <em class="fas fa-star"></em>
                  <span class="pl-2">รายการโปรด</span>
                </v-btn>
              </template>
              <div
                :class="{ 'custom-livechat-quick-msg': ['dentalhub'].includes(selectedBot.type) }"
              >
                <v-btn @click="isEdit = true" depressed color="primary">{{
                  $t('Edit/Send')
                }}</v-btn>
                <v-btn
                  fab
                  outline
                  color="primary"
                  class="extra-small ma-1"
                  v-if="
                    ticket2showdelete &&
                    !isEdit &&
                    intent.intentname != '{default}' &&
                    !['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname) &&
                    !hideDelete
                  "
                  @click="$emit('onDelete')"
                >
                  <em class="fa fa-trash middle" />
                </v-btn>
                <v-btn
                  v-if="kfcpagemustedit"
                  depressed
                  color="primary"
                  @click="sendToLivechat(intent)"
                  >{{ $t('Send') }}
                </v-btn>
              </div>
            </div>
          </template>
        </div>
      </v-flex>

      <v-flex xs10 class="pa-1">
        <v-chip
          small
          color="#00c300"
          text-color="white"
          v-if="
            $store.state.linenotifylist.length > 0 &&
            ((intent.linenoti_status && selectedBot.notify_intent && !isCommentToInbox) ||
              (intent.linenoti_status && selectedBot.notify_comment && isCommentToInbox))
          "
          disabled
        >
          <v-avatar>
            <em class="fas fa-bell" />
          </v-avatar>
          {{ $t('Line Notify') }}
        </v-chip>

        <v-chip
          small
          :color="intentStatus.isStarttime ? '#a0e83d' : 'red'"
          text-color="white"
          v-if="intent.starttime"
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          <template v-if="intent.starttime">
            Start
            <template v-if="intent.onlytime">{{ intent.starttime | DateFormat('HH:mm') }}</template>
            <template v-else>{{ intent.starttime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
          </template>
        </v-chip>
        <v-chip
          small
          :color="intentStatus.isEndtime ? '#a0e83d' : 'red'"
          text-color="white"
          v-if="intent.endtime"
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          <template v-if="intent.endtime">
            End
            <template v-if="intent.onlytime">{{ intent.endtime | DateFormat('HH:mm') }}</template>
            <template v-else>{{ intent.endtime | DateFormat('DD/MM/YYYY HH:mm') }}</template>
          </template>
        </v-chip>
      </v-flex>
      <v-flex xs2 class="text-xs-right pa-1">
        <template v-if="!isEdit">
          <div>
            <span
              class="fas"
              :style="`font-size: 1.5em;margin-right: 5px; cursor: pointer; color: ${$vuetify.theme.primary}`"
              :class="{ 'fa-chevron-down': !showDetail, 'fa-chevron-up': showDetail }"
            ></span>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="isEdit || showDetail">
      <template v-if="isEdit">
        <manage-intent
          @sendtolivechat="sendToLivechat"
          :type="'edit'"
          :livechat="livechat"
          :isLiveStream="isLiveStream"
          :isCommentToInbox="isCommentToInbox"
          v-model="intent"
          @close="onClose"
          @saveIntent="onSave"
          :isDefault="
            intent.intentname == '{default}' ||
            ['{default_comment_to_inbox}', '{default_live}'].includes(intent.intentname)
          "
          :hideQuestion="hideQuestion"
          :hideAdvanceOptions="hideAdvanceOptions"
          :hideSetting="hideSetting"
          :hidePriority="hidePriority"
          :hideChoice="hideChoice"
          :readonlyName="readonlyName"
          :excludedIntentName="excludedIntentName"
          :availableBubbles="availableBubbles"
          :hideStatus="hideStatus"
        ></manage-intent>
      </template>
      <template v-else>
        <v-divider></v-divider>
        <v-layout wrap justify-end>
          <div v-if="!hidePriority">
            <v-checkbox
              class="mt-1 mb-1 pr-2"
              v-model="intent.ispriority"
              disabled
              hide-details
              :label="$t('First Priority')"
            ></v-checkbox>
          </div>
        </v-layout>
        <v-layout wrap>
          <v-flex v-if="!livechat" xs12 sm6>
            <div class="question pa-2">
              <template
                v-if="
                  ['{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
                    intent.intentname
                  ) || hideQuestion
                "
              ></template>
              <template v-else>
                <p>{{ $t('customer says') }}</p>
                <template v-if="normal && normal.length > 0">
                  <label class="caption">{{ $t('Sentence') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <!-- :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`" -->
                    <li
                      class="tag"
                      :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`"
                      v-for="(question, index) in normal"
                      :key="'normal_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="keyword && keyword.length > 0">
                  <label class="caption">{{ $t('Keyword') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      :style="`border: 1px solid ${$vuetify.theme.primary} !important; color: ${$vuetify.theme.primary} !important`"
                      v-for="(question, index) in keyword"
                      :key="'keyword_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template v-if="exactly && exactly.length > 0">
                  <label class="caption">{{ $t('Exact word') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in exactly"
                      :key="'exactly_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :nohtml="true" :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="startwith && startwith.length > 0 && $store.getters.getPackage == 'premium'"
                >
                  <label class="caption">{{ $t('Start with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in startwith"
                      :key="'startwith_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="endwith && endwith.length > 0 && $store.getters.getPackage == 'premium'"
                >
                  <label class="caption">{{ $t('End with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in endwith"
                      :key="'endwith_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>
                <template
                  v-if="
                    startandendwith &&
                    startandendwith.length > 0 &&
                    $store.getters.getPackage == 'premium'
                  "
                >
                  <label class="caption">{{ $t('Start and End with') }}</label>
                  <ul class="tags" style="margin-bottom: 5px">
                    <li
                      class="tag"
                      v-for="(question, index) in startandendwith"
                      :key="'startandendwith_question_' + index"
                      :class="{ disabled: !question.checkLang }"
                    >
                      <specialtext :text="question.text"></specialtext>
                      <em class="mark fas fa-exclamation-circle" />
                    </li>
                  </ul>
                </template>

                <label v-show="isOtherLang && $store.getters.getPackage != 'premium'">
                  <em class="fas fa-exclamation-circle" />
                  {{
                    $t(
                      'Basic Package supports only Thai and English languages. Other languages, please Upgrade to Premium'
                    )
                  }}
                </label>
              </template>
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <template v-if="answers">
              <div class="answer pa-2">
                <template v-if="isCommentToInbox">
                  <p>{{ $t('Chatbot answers') }}</p>

                  <template v-if="answers && answers[0].length > 0">
                    <message-viewer v-model="answers"></message-viewer>
                  </template>
                  <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                </template>
                <template v-else>
                  <p>{{ $t('Chatbot answers') }}</p>
                  <template v-if="intent.a_type == 'json'">
                    <div>
                      <template v-if="!showMultipleChannel">
                        <template v-if="answers && answers[0].length > 0">
                          <message-viewer v-model="answers"></message-viewer>
                        </template>
                        <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                      </template>
                      <template v-else>
                        <v-layout>
                          <v-flex class="channel" shrink style="border-right: 1px solid #eee">
                            <div
                              :class="{ 'primary white--text': tab == 'fb' }"
                              @click="tab = 'fb'"
                              class="py-1 pl-2 pr-2"
                              style="
                                border: 1px solid #eee;
                                border-width: 1px 0px 1px 1px;
                                border-top-left-radius: 5px;
                                border-bottom-left-radius: 5px;
                                cursor: pointer;
                              "
                            >
                              <span class="fab fa-facebook"></span>
                            </div>
                            <div
                              :class="{ 'primary white--text': tab == 'line' }"
                              @click="tab = 'line'"
                              class="py-1 pl-2 pr-2"
                              style="
                                border: 1px solid #eee;
                                border-width: 1px 0px 1px 1px;
                                border-top-left-radius: 5px;
                                border-bottom-left-radius: 5px;
                                cursor: pointer;
                              "
                            >
                              <span class="fab fa-line"></span>
                            </div>
                            <div
                              :class="{ 'primary white--text': tab == 'ig' }"
                              @click="tab = 'ig'"
                              class="py-1 pl-2 pr-2"
                              style="
                                border: 1px solid #eee;
                                border-width: 1px 0px 1px 1px;
                                border-top-left-radius: 5px;
                                border-bottom-left-radius: 5px;
                                cursor: pointer;
                              "
                            >
                              <span class="fab fa-instagram"></span>
                            </div>
                          </v-flex>
                          <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                            <template v-if="tab == 'fb'">
                              <template v-if="fbanswers && fbanswers[0].length > 0">
                                <message-viewer v-model="fbanswers"></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                            <template v-else-if="tab == 'line'">
                              <template v-if="lineanswers && lineanswers[0].length > 0">
                                <message-viewer v-model="lineanswers"></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                            <template v-else-if="tab == 'ig'">
                              <template v-if="iganswers && iganswers[0].length > 0">
                                <message-viewer v-model="iganswers"></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>
                          </v-flex>
                        </v-layout>
                      </template>
                    </div>
                  </template>
                  <template v-else-if="intent.a_type == 'text'">
                    <div style="overflow-x: auto">
                      <div>
                        <div
                          v-for="(answer, index) in answers"
                          :key="'answer_' + index"
                          style="margin-bottom: 5px; flex-grow: 1; padding: 0px 10px"
                          :style="{ 'border-right': answers.length > 1 ? '1px dashed #eee' : '' }"
                        >
                          <div v-for="(message, mindex) in answer" :key="'message_' + mindex">
                            <template v-if="message.type == 'text'">
                              <div
                                class="message"
                                style="
                                  float: left;
                                  position: relative;
                                  border-radius: 12px;
                                  max-width: 181px;
                                  overflow-wrap: break-word;
                                  min-height: 22px;
                                  min-width: 14px;
                                  line-height: 15.36px;
                                  overflow: hidden;
                                  margin-bottom: 5px;
                                "
                              >
                                <div style="font-size: 12px; color: black">
                                  <div style="padding: 5px 8px 6px; background-color: #f1f0f0">
                                    <span style="line-height: 15.36px">
                                      <specialtext :text="message.value.text"></specialtext>
                                    </span>
                                  </div>
                                </div>
                                <div class="clearfix"></div>
                                <div
                                  v-if="message.value.buttons.length > 0"
                                  style="
                                    float: left;
                                    width: 100%;
                                    border: 1px solid #eee;
                                    border-bottom-left-radius: 12px;
                                    border-bottom-right-radius: 12px;
                                    overflow: hidden;
                                  "
                                >
                                  <ul
                                    class="list-group list-group-flush"
                                    style="margin-bottom: 0px"
                                  >
                                    <li
                                      class="list-group-item"
                                      style="
                                        border: none;
                                        border-top: 1px solid #eee;
                                        border-radius: 0px;
                                        text-align: center;
                                        padding: 2px 15px;
                                      "
                                      v-for="(button, bindex) in message.value.buttons"
                                      :key="bindex"
                                      :style="{
                                        'border-top': bindex != 0 ? '1px solid #eee' : 'none'
                                      }"
                                    >
                                      <span style="color: #0084ff">{{ button.title }}</span>
                                      <p style="margin: 0; font-size: 10px">
                                        <template v-if="button.type == 'web_url'">
                                          {{ button.url }}
                                        </template>
                                        <template v-if="button.type == 'postback'">
                                          {{ button.payload }}
                                        </template>
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="message.type == 'image'">
                              <div
                                class="message"
                                style="
                                  float: left;
                                  position: relative;
                                  border-radius: 12px;
                                  width: 181px;
                                  overflow-wrap: break-word;
                                  min-height: 22px;
                                  min-width: 14px;
                                  line-height: 15.36px;
                                  overflow: hidden;
                                  margin-bottom: 5px;
                                "
                              >
                                <div style="font-size: 12px; color: black">
                                  <img :src="message.value" alt style="width: 100%" />
                                </div>
                              </div>
                            </template>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="intent.a_type == 'template'">
                    <generic-viewer v-model="answers"></generic-viewer>
                  </template>
                  <template v-else-if="intent.a_type == 'message' || intent.a_type == 'generic'">
                    <intent-getstarted v-model="welcomemessage"></intent-getstarted>
                  </template>
                  <template v-else-if="intent.a_type == 'viewsummary'">
                    <view-cart-summary-viewer></view-cart-summary-viewer>
                  </template>
                  <template v-else-if="intent.a_type == 'none'" class="pl-1">{{
                    $t('No reply')
                  }}</template>
                </template>

                <template v-if="answers[0].length > 0">
                  <div v-if="!isCommentToInbox && !hideChoice">
                    <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                    <div class="quickreply">
                      <template v-if="replies.length > 0">
                        <ul class="tags">
                          <li class="tag" v-for="(reply, index) in replies" :key="'reply_' + index">
                            {{ reply }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>-</template>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </v-flex>
        </v-layout>
        <div class="my-3" v-if="selectedBot && selectedBot.type === 'hopinnhr'">
          <v-layout wrap>
            <v-flex xs6 class="pa-2">
              <div class="caption">ตำแหน่ง</div>
              <div>{{ intent.custom_filter_2 ? intent.custom_filter_2 : 'All' }}</div>
            </v-flex>
            <v-flex xs6 class="pa-2">
              <div class="caption">สังกัด</div>
              <div>{{ intent.custom_filter_1 ? intent.custom_filter_1 : 'All' }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div
          v-if="
            intent.userstatus ||
            (intent.linenoti_status && intent.linenoti_text && intent.linenoti_text.trim() != '') ||
            (intent.context_in && !['comment', 'facebooklive'].includes(intent.context_in)) ||
            intent.context_out ||
            (usertags && usertags.length > 0) ||
            intent.remaining_reply != null ||
            intent.hasOwnProperty('notreplysameperson') ||
            intent.intentgroup ||
            intent.follow_up_status
          "
        >
          <v-divider></v-divider>

          <v-tabs v-model="advancedTab" slider-color="primary" touchless>
            <v-tab v-if="showAdvancedMenu('customer')" :key="0" :href="'#tab-0'" ripple>{{
              $t('Customer')
            }}</v-tab>
            <v-tab
              :key="1"
              :href="'#tab-1'"
              ripple
              v-if="!isCommentToInbox && showAdvancedMenu('context')"
              >{{ $t('Context') }}</v-tab
            >
            <v-tab :key="2" :href="'#tab-2'" ripple v-if="showAdvancedMenu('timer')">{{
              $t('Timer')
            }}</v-tab>
            <v-tab :key="3" :href="'#tab-3'" ripple v-if="showAdvancedMenu('line_notify')">{{
              $t('Line Notify')
            }}</v-tab>
            <v-tab
              :key="4"
              :href="'#tab-4'"
              v-show="false && isCommentToInbox && showAdvancedMenu('limit_reply_to_inbox')"
              ripple
              >{{ $t('Limit reply to inbox') }}</v-tab
            >
            <v-tab
              :key="5"
              :href="'#tab-5'"
              ripple
              v-if="showAdvancedMenu('intent_group') && showIntentGroup"
              >{{ $t('Intent Group') }}</v-tab
            >
            <v-tab :key="7" href="#tab-7" ripple v-if="showAdvancedMenu('follow_up')">{{
              $t('Follow Up')
            }}</v-tab>

            <v-tab-item :key="0" :value="'tab-0'">
              <v-card flat>
                <v-card-text>
                  <div>
                    <div class="caption">{{ $t('Status') }}</div>
                    <p class="primary-color">{{ intent.userstatus ? intent.userstatus : '-' }}</p>
                  </div>
                  <div>
                    <div class="caption">{{ $t('Tag') }}</div>
                    <ul class="tags pt-1">
                      <li
                        class="tag"
                        v-for="(usertag, index) in usertags"
                        :key="'usertag_' + index"
                      >
                        <specialtext :text="usertag"></specialtext>
                      </li>
                    </ul>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="1" :value="'tab-1'" v-if="!isCommentToInbox">
              <v-card flat>
                <v-card-text>
                  <v-layout>
                    <template v-if="!['comment', 'facebooklive'].includes(intent.context_in)">
                      <v-flex>
                        <div class="caption">Context In</div>
                        <p class="primary-color">
                          {{ intent.context_in ? intent.context_in : '-' }}
                        </p>
                      </v-flex>
                    </template>
                    <template>
                      <v-flex>
                        <div class="caption">Context Out</div>
                        <p class="primary-color">
                          {{ intent.context_out ? intent.context_out : '-' }}
                        </p>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2" :value="'tab-2'">
              <v-card flat>
                <v-card-text>
                  <v-layout>
                    <template>
                      <v-flex>
                        <div class="caption">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                        </div>
                        <div class="primary-color">
                          {{
                            intent.starttime
                              ? moment(intent.starttime).format('DD-MM-YYYY HH:mm')
                              : '-'
                          }}
                        </div>
                      </v-flex>
                      <v-flex>
                        <div class="caption">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                        </div>
                        <div class="primary-color">
                          {{
                            intent.endtime ? moment(intent.endtime).format('DD-MM-YYYY HH:mm') : '-'
                          }}
                        </div>
                      </v-flex>
                    </template>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="3" :value="'tab-3'">
              <v-card flat>
                <v-card-text>
                  <template>
                    <div class="caption">{{ $t('Line Notify') }}</div>
                    <div class="primary-color">
                      {{ intent.linenoti_text ? intent.linenoti_text : '-' }}
                    </div>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="4" :value="'tab-4'">
              <v-card
                flat
                :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="col s12 form-control">
                    <div class="caption">{{ $t('Reply to comment (amount)') }}</div>
                    <p class="primary-color">
                      {{ intent.remaining_reply != null ? intent.remaining_reply : '-' }}
                    </p>

                    <div class="caption">{{ $t('Reply once/person') }}</div>
                    <p class="primary-color">
                      {{ intent.notreplysameperson ? $t('active') : $t('inactive') }}
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="5" :value="'tab-5'">
              <v-card flat>
                <v-card-text>
                  <v-layout
                    v-if="
                      [
                        'ticket',
                        'ticket2',
                        'studio7',
                        'ustore',
                        'tdtawandang',
                        'cityfresh'
                      ].includes(selectedBot.theme) ||
                      [...$store.state.ticketPageid, ...$store.state.toaPaintPage].includes(
                        selectedBot.pageid
                      ) ||
                      ['gpf'].includes(selectedBot.type)
                    "
                    row
                    wrap
                  >
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Group') }}</div>
                        <p class="primary-color">
                          {{
                            intentgroup.assigngroupid &&
                            agentGroup.find((el) => el.id == intentgroup.assigngroupid)
                              ? agentGroup.find((el) => el.id == intentgroup.assigngroupid)
                                  .groupname
                              : '-'
                          }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Sub Group') }}</div>
                        <p class="primary-color">
                          {{
                            intentgroup.assignsubgroupid &&
                            agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid)
                              ? agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid)
                                  .subgroupname
                              : '-'
                          }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Priority') }}</div>
                        <p class="primary-color">
                          {{ intentgroup.priority ? intentgroup.priority : '-' }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Due Date') }}</div>
                        <p class="primary-color">
                          {{ intentgroup.duedate ? intentgroup.duedate : '-' }}
                        </p>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption">{{ $t('Tags') }}</div>
                        <p class="primary-color">
                          {{ intentgroup.tags ? intentgroup.tags : '-' }}
                        </p>
                      </div>
                    </v-flex>
                  </v-layout>
                  <div v-else>
                    <div class="caption">{{ $t('Intent Group') }}</div>
                    <p class="primary-color">{{ intentgroup }}</p>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item :key="7" :value="'tab-7'"
              ><v-card flat>
                <v-card-text>
                  <div>
                    <h4 class="mt-3 mb-2 header" style="font-size: 15px">
                      {{ $t('this_message_within_24_hours') }}
                    </h4>
                    <h4 class="mb-2 title" v-if="isCommentToInbox">
                      {{
                        $t(
                          `If user haven't sent message in inbox ,The follow-up message won't be sent`
                        )
                      }}
                    </h4>
                    <p>
                      {{ $t('status') }}
                      <span v-if="intent.follow_up_status">
                        <v-icon color="green">circle</v-icon> {{ $t('open') }}</span
                      ><span v-else> <v-icon color="red">circle</v-icon> {{ $t('close') }}</span>
                    </p>
                    <p>
                      <span
                        >{{
                          Math.floor(parseInt(intent.follow_up_within_seconds) / 60 / 60) || '-'
                        }}
                        {{ $t('hour') }}</span
                      >
                      <span
                        >{{ (parseInt(intent.follow_up_within_seconds) / 60) % 60 || '-' }}
                        {{ $t('minute') }}</span
                      >
                    </p>

                    <template v-if="intent.follow_up_type == 'json'">
                      <div>
                        <v-layout>
                          <v-flex style="overflow: auto; min-height: 100px" class="ml-1">
                            <template v-if="isCommentToInbox">
                              <p class="mt-3">{{ $t('Chatbot answers') }}</p>
                              <template v-if="answersFollowUp && answersFollowUp[0].length > 0">
                                <message-viewer v-model="answersFollowUp"></message-viewer>
                              </template>
                              <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                            </template>

                            <template v-else>
                              <p>{{ $t('Chatbot answers') }}</p>
                              <template v-if="intent.a_type == 'json'">
                                <div>
                                  <template v-if="!showMultipleChannelFollowUp">
                                    <template
                                      v-if="answersFollowUp && answersFollowUp[0].length > 0"
                                    >
                                      <message-viewer
                                        v-model="answersFollowUp"
                                        :channel="tabFollowUp"
                                      ></message-viewer>
                                    </template>
                                    <p v-else class="primary-color pl-1">{{ $t('No reply') }}</p>
                                  </template>
                                  <template v-else>
                                    <v-layout>
                                      <v-flex
                                        class="channel"
                                        shrink
                                        style="border-right: 1px solid #eee"
                                      >
                                        <template
                                          v-for="social in $store.state.socialChannelOptions"
                                        >
                                          <div
                                            :class="{
                                              'primary white--text': tabFollowUp == social.value
                                            }"
                                            @click="tabFollowUp = social.value"
                                            class="py-1 pl-2 pr-2"
                                            style="
                                              border: 1px solid #eee;
                                              border-width: 1px 0px 1px 1px;
                                              border-top-left-radius: 5px;
                                              border-bottom-left-radius: 5px;
                                              cursor: pointer;
                                            "
                                            :key="`tab-${social.value}`"
                                          >
                                            <span :class="social.icon"></span>
                                          </div>
                                        </template>
                                      </v-flex>
                                      <v-flex
                                        style="overflow: auto; min-height: 100px"
                                        class="ml-1"
                                      >
                                        <template
                                          v-for="social in $store.state.socialChannelOptions"
                                        >
                                          <div
                                            v-show="tabFollowUp == social.value"
                                            :key="`message-${social.value}`"
                                          >
                                            <template
                                              v-if="
                                                multiFollowUpMessages[
                                                  `follow_up_${social.value}_messages`
                                                ] &&
                                                multiFollowUpMessages[
                                                  `follow_up_${social.value}_messages`
                                                ][0].length > 0
                                              "
                                            >
                                              <message-viewer
                                                v-model="
                                                  multiFollowUpMessages[
                                                    `follow_up_${social.value}_messages`
                                                  ]
                                                "
                                                :channel="tabFollowUp"
                                              ></message-viewer>
                                            </template>
                                            <p v-else class="primary-color pl-1">
                                              {{ $t('No reply') }}
                                            </p>
                                          </div>
                                        </template>
                                      </v-flex>
                                    </v-layout>
                                  </template>
                                </div>
                              </template>
                            </template>
                            <template>
                              <div v-if="!isCommentToInbox">
                                <p class="caption" style="margin-top: 10px">{{ $t('Choice') }}</p>
                                <div class="quickreply">
                                  <template v-if="follow_up_quick_reply.length > 0">
                                    <ul class="tags">
                                      <li
                                        class="tag"
                                        v-for="(reply, index) in follow_up_quick_reply"
                                        :key="'follow_up_quick_reply' + index"
                                      >
                                        {{ reply }}
                                      </li>
                                    </ul>
                                  </template>
                                  <template v-else>-</template>
                                </div>
                              </div>
                            </template>
                          </v-flex>
                        </v-layout>
                      </div>
                      <div>
                        <v-divider></v-divider>

                        <v-tabs slider-color="primary" touchless show-arrows>
                          <v-tab
                            :key="0"
                            :href="'#subtab-0'"
                            ripple
                            v-if="showAdvancedMenu('customer')"
                            >{{ $t('Customer') }}</v-tab
                          >
                          <v-tab
                            :key="1"
                            :href="'#subtab-1'"
                            ripple
                            v-if="!isCommentToInbox && showAdvancedMenu('context')"
                            >{{ $t('Context') }}</v-tab
                          >
                          <v-tab
                            :key="2"
                            :href="'#subtab-2'"
                            v-if="showAdvancedMenu('line_notify')"
                            ripple
                            >{{ $t('Line Notify') }}</v-tab
                          >
                          <v-tab-item :key="0" :value="'subtab-0'">
                            <v-card flat>
                              <v-card-text>
                                <div>
                                  <div class="caption">{{ $t('Status') }}</div>
                                  <p class="primary-color">
                                    {{
                                      intent.follow_up_userstatus
                                        ? intent.follow_up_userstatus
                                        : '-'
                                    }}
                                  </p>
                                </div>
                                <div>
                                  <div class="caption">{{ $t('Tag') }}</div>
                                  <ul class="tags pt-1">
                                    <li
                                      class="tag"
                                      v-for="(usertag, index) in follow_up_usertags"
                                      :key="'usertag_' + index"
                                    >
                                      <specialtext :text="usertag"></specialtext>
                                    </li>
                                  </ul>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item :key="1" :value="'subtab-1'" v-if="!isCommentToInbox">
                            <v-card flat>
                              <v-card-text>
                                <v-layout>
                                  <template>
                                    <v-flex>
                                      <div class="caption">Context Out</div>
                                      <p class="primary-color">
                                        {{
                                          intent.follow_up_context_out
                                            ? intent.follow_up_context_out
                                            : '-'
                                        }}
                                      </p>
                                    </v-flex>
                                  </template>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item :key="2" :value="'subtab-2'">
                            <v-card flat>
                              <v-card-text>
                                <div class="caption">{{ $t('Line Notify') }}</div>
                                <div class="primary-color">
                                  {{
                                    intent.follow_up_linenoti_text
                                      ? intent.follow_up_linenoti_text
                                      : '-'
                                  }}
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs>
                      </div>
                    </template>
                  </div>
                </v-card-text>
              </v-card></v-tab-item
            >
          </v-tabs>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import specialtext from '@/components/elements/specialtext'
import IntentGetstarted from './IntentGetstarted'
import GenericViewer from '@/components/elements/GenericViewer'
import MessageViewer from '@/components/elements/MessageViewer'
import ModalDialog from '@/components/elements/ModalDialog'
import FacebookScreen from '@/components/elements/FacebookScreen'
import api from '@/api'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'
import IntentSelectPostLabel from './IntentSelectPostLabel'
import cloneDeep from 'lodash/cloneDeep'
import intentApi from '@/api/intent'

export default {
  props: {
    value: {
      default: null
    },
    excludedIntentName: {
      default: ''
    },
    isCommentToInbox: {
      default: null
    },
    filterIntents: {
      default: null
    },
    isLiveStream: {
      default: null
    },
    livechat: {
      default: false
    },
    hideCopy: {
      default: false
    },
    hideDelete: {
      default: false
    },
    hideQuestion: {
      default: false
    },
    hideAdvanceOptions: {
      default: null
    },
    hideSetting: {
      default: false
    },
    hidePriority: {
      default: false
    },
    readonlyName: {
      default: false
    },
    availableBubbles: {},
    hideChoice: {
      default: false
    },
    hideStatus: {
      default: false
    }
  },

  data: function () {
    return {
      isEdit: false,
      intent: this.value,
      // showDetail: false,
      showPreview: false,
      normal: [],
      keyword: [],
      exactly: [],
      startwith: [],
      endwith: [],
      startandendwith: [],
      isOtherLang: false,
      advancedTab: null,
      showMultipleChannel: false,
      tab: 'fb',
      tabFollowUp: 'all',
      follow_up_quick_reply: [],
      follow_up_val: [],
      follow_up_within_seconds: [],
      showMultipleChannelFollowUp: false
    }
  },
  mounted: function () {
    if (this.intent) {
      // this.showDetail = this.intent.isShow
      this.formatData(this.intent.q_val)
      this.handleMultiChannel()
      this.handleMultiFollowUpChannel()
    }
  },
  components: {
    'manage-intent': manageIntent,
    specialtext,
    IntentGetstarted,
    GenericViewer,
    ModalDialog,
    FacebookScreen,
    MessageViewer,
    ViewCartSummaryViewer,
    ToggleButton,
    IntentSelectPostLabel
  },
  computed: {
    showIntentGroup() {
      return (
        (!this.isCommentToInbox &&
          this.$store.getters.showIntentGroup &&
          this.showAdvancedMenu('intent_group')) ||
        (this.isCommentToInbox &&
          [...this.$store.state.oceanlifePage, ...this.$store.state.rabbitReplyFBPostPage].includes(
            this.selectedBot.pageid
          ))
      )
    },
    moment() {
      return moment
    },
    follow_up_usertags: function () {
      const vm = this
      if (vm.intent.follow_up_usertags !== '' && vm.intent.follow_up_usertags != null) {
        let usertags = vm.intent.follow_up_usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    ticket2showdelete() {
      return !this.livechat || this.intent.q_val === 'exacts(intent_type_quick_message)'
    },
    kfcpagemustedit() {
      if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
        if (this.intent.intentname.startsWith('t1') || this.intent.intentname.startsWith('s1')) {
          return false
        } else return true
      } else return true
    },
    intentgroup() {
      if (this.intent.intentgroup) {
        if (
          ['ticket', 'ticket2', 'studio7', 'ustore', 'tdtawandang', 'cityfresh'].includes(
            this.selectedBot.theme
          ) ||
          [...this.$store.state.ticketPageid, ...this.$store.state.toaPaintPage].includes(
            this.selectedBot.pageid
          ) ||
          ['gpf'].includes(this.selectedBot.type)
        ) {
          try {
            return JSON.parse(this.intent.intentgroup)
          } catch (error) {
            return this.intent.intentgroup
            console.log(error)
          }
        } else {
          return this.intent.intentgroup
        }
      } else {
        return '-'
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomemessage: 'welcomeMessage',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),
    intentStatus() {
      let vm = this
      let starttime = vm.intent.starttime
        ? vm.intent.onlytime
          ? moment().format('YYYY-MM-DD') + ' ' + moment(vm.intent.starttime).format('HH:mm')
          : vm.intent.starttime
        : null
      let endtime = vm.intent.endtime
        ? vm.intent.onlytime
          ? moment().format('YYYY-MM-DD') + ' ' + moment(vm.intent.endtime).format('HH:mm')
          : vm.intent.endtime
        : null

      var isOnline = false
      var isStarttime = false
      var isEndtime = false

      if (endtime == null && starttime == null) {
        isOnline = this.intent.intentstatus
      } else if (starttime == null && moment() < moment(endtime)) {
        isOnline = this.intent.intentstatus
        isEndtime = true
      } else if (endtime == null && moment() > moment(starttime)) {
        isOnline = this.intent.intentstatus
        isStarttime = true
      } else if (moment(endtime) < moment(starttime)) {
        isOnline =
          this.intent.intentstatus && (moment() >= moment(starttime) || moment() <= moment(endtime))
        isStarttime = isEndtime = moment() >= moment(starttime) || moment() <= moment(endtime)
      } else {
        isOnline = this.intent.intentstatus && moment().isBetween(starttime, endtime)
        isStarttime = isEndtime = moment().isBetween(starttime, endtime)
      }

      // if (starttime == null && moment() < moment(endtime)) {
      //   isEndtime = true
      // }
      // if (endtime == null && moment() > moment(starttime)) {
      //   isStarttime = true
      // }
      // if(starttime == null )

      return {
        isOnline: isOnline,
        isStarttime: isStarttime,
        isEndtime: isEndtime
      }
    },
    questions: function () {
      if (this.intent.q_val !== '') {
        return this.intent.q_val.split(',')
      } else {
        return ''
      }
    },
    answers: function () {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.a_val, vm.intent.a_type)
      } catch (error) {
        return [[]]
      }
    },
    fbanswers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.fb_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    lineanswers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.line_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    iganswers() {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.ig_val, 'json')
      } catch (error) {
        return [[]]
      }
    },
    replies: function () {
      var vm = this
      if (vm.intent.quick_reply !== '' && vm.intent.quick_reply != null) {
        var replies = vm.intent.quick_reply.split(',')
        return replies
      } else {
        return []
      }
    },
    usertags: function () {
      var vm = this
      if (vm.intent.usertags !== '' && vm.intent.usertags != null) {
        var usertags = vm.intent.usertags.split(',')
        return usertags
      } else {
        return []
      }
    },
    postidlist: function () {
      var vm = this
      var includes = []
      var excludes = []
      var post_keywords = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      if (vm.intent.post_keywords && vm.intent.post_keywords != '') {
        try {
          post_keywords = JSON.parse(vm.intent.post_keywords)
        } catch (error) {
          post_keywords = vm.intent.post_keywords.split(',')
        }
      }
      return { includes: includes, excludes: excludes, post_keywords: post_keywords }
    },
    showDetail: function () {
      if (!this.isEdit) {
        return this.intent.isShow
      } else {
        return true
      }
    },
    answersFollowUp: function () {
      var vm = this
      try {
        return this.formatAnswer(vm.intent.follow_up_val, vm.intent.follow_up_type)
      } catch (error) {
        return [[]]
      }
    },
    multiFollowUpMessages() {
      const multipleMessages = this.$store.state.socialChannelOptions.reduce((prev, curr) => {
        let messages = [[]]
        try {
          messages = this.formatAnswer(this.intent[`follow_up_${curr.value}_val`], 'json')
        } catch (error) {
          console.error(error)
        }
        prev[`follow_up_${curr.value}_messages`] = messages
        return prev
      }, {})
      return multipleMessages
    }
  },
  methods: {
    showAdvancedMenu(type) {
      if (this.hideAdvanceOptions) {
        return !this.hideAdvanceOptions.includes(type)
      } else {
        return true
      }
    },
    onChangeIntentStatus: function () {
      let intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
      this.$set(this.intent, 'intentstatus', !intentstatus)
      let data = {
        ...this.intent
      }
      var vm = this
      vm.$store.dispatch('loading')
      api
        .editIntent(data, function (error, response) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }
          vm.$store.dispatch('loading')
        })
        .catch((err) => {
          console.log(err)
        })
    },
    editIntent() {
      this.isEdit = true
      this.$store.commit('ADD_EDITTING_INTENT', this.intent.id)
    },
    sendToLivechat(intent) {
      this.$emit('sendToLivechat', intent)
    },
    handleMultiFollowUpChannel() {
      const hasMultipleChannel = this.$store.state.socialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`) &&
          this.intent[`follow_up_${social.value}_val`]
        )
      })
      if (hasMultipleChannel) {
        this.showMultipleChannelFollowUp = true
      }

      if (this.showMultipleChannelFollowUp) {
        try {
          this.tabFollowUp = hasMultipleChannel.value
          this.channels = this.$store.state.socialChannelOptions
            .map((social) => {
              if (
                multiFollowUpMessages[`follow_up_${social.type}.messages`].length > 0 &&
                multiFollowUpMessages[`follow_up_${social.type}.messages`].length > 0
              ) {
                return social.type
              } else {
                return null
              }
            })
            .filter((social) => social)
        } catch (error) {
          this.tab = 'fb'
        }
      }
    },
    handleMultiChannel() {
      const hasMultipleChannel = this.$store.state.socialChannelOptions.find((social) => {
        return (
          Object.prototype.hasOwnProperty.call(this.intent, `${social.value}_val`) &&
          this.intent[`${social.value}_val`]
        )
      })
      if (hasMultipleChannel) {
        this.showMultipleChannel = hasMultipleChannel
      }
    },

    onSave: function (payload) {
      this.handleMultiChannel()
      this.handleMultiFollowUpChannel()
      this.isEdit = false
      this.$store.commit('REMOVE_EDITTING_INTENT', this.intent.id)
    },
    onClose: function (payload) {
      this.isEdit = false
      this.$store.commit('REMOVE_EDITTING_INTENT', this.intent.id)
    },
    toggleDetail: function () {
      this.intent.isShow = !this.intent.isShow
    },
    onCopyMyIntent: function () {
      let vm = this
      let data = {
        ...cloneDeep(vm.intent)
      }
      data.pageid = vm.selectedBot.pageid
      data.intentname = data.intentname + '_' + moment().format('x')
      data.a_val = data.a_val.replace(/ /gim, ' ')

      this.$emit('onCopyIntent', {
        onCopy: function () {
          return new Promise(async (resolve, reject) => {
            var result = await vm.$swal.fire({
              title: vm.$t('Do you want to copy {name}?', {
                name: vm.intent.intentname.replace(/\<|\>/g, '')
              }),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('cancel'),
              reverseButtons: true
            })
            if (result.value) {
              vm.$store.dispatch('loading')
              api.addIntent(data, function (error, response) {
                if (error) {
                  console.error(error)
                  vm.$store.dispatch('loading')
                  reject()
                }
                data.id = response.id
                resolve(data)
                vm.$store.dispatch('loading')
              })
            }
          })
        }
      })
    },
    formatData: function (text) {
      var vm = this
      var questions = text && text !== '' ? text.split(',') : []
      var isPremium = vm.$store.getters.getPackage === 'premium'
      vm.normal = []
      vm.keyword = []
      vm.exactly = []
      vm.startwith = []
      vm.endwith = []
      vm.startandendwith = []
      if (questions) {
        questions.map(function (question, index) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.endwith.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.startandendwith.push({
              text: keyword,
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.keyword.push({ text: keyword, checkLang: vm.isSupportLanguage(keyword, isPremium) })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            vm.exactly.push({
              text: keyword.trim(),
              checkLang: vm.isSupportLanguage(keyword, isPremium)
            })
            if (!vm.isSupportLanguage(keyword, isPremium)) {
              vm.isOtherLang = true
            }
          } else {
            vm.normal.push({ text: question, checkLang: vm.isSupportLanguage(question, isPremium) })
            if (!vm.isSupportLanguage(question, isPremium)) {
              vm.isOtherLang = true
            }
          }
        })
      }
    },
    formatAnswer(a_val, a_type) {
      var vm = this
      if (vm.isCommentToInbox || vm.isLiveStream) {
        if (vm.isJsonParseable(a_val)) {
          return JSON.parse(a_val)
        } else {
          return [
            [
              {
                type: 'text',
                text: a_val
              }
            ]
          ]
        }
      } else if (a_val == '{welcome_message}') {
        return [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (a_type == 'json') {
        return JSON.parse(a_val)
      } else if (a_val != '' && a_type == 'text') {
        var newGroup = []
        var group_messages = a_val.split('||')
        $.each(group_messages, function (index, group) {
          var messages = group.split('#nl')
          var newMessages = []
          $.each(messages, function (inedx, message) {
            if (vm.isURL(message)) {
              newMessages.push({
                type: 'image',
                value: message
              })
            } else if (!isNaN(message)) {
              newMessages.push({
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              })
            } else if (vm.isJsonParseable(message)) {
              newMessages.push({
                type: 'text',
                value: JSON.parse(message)
              })
            } else {
              newMessages.push({
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              })
            }
          })
          newGroup.push(newMessages)
        })

        return newGroup
      } else if (a_type == 'template') {
        if (vm.isJsonParseable(a_val)) {
          return JSON.parse(a_val)
        } else {
          return []
        }
      } else if (a_type == 'message') {
        return [
          [
            {
              type: 'text',
              text: a_val
            }
          ]
        ]
      } else if (a_type == 'none') {
        return [[]]
      } else if (a_type == 'viewsummary') {
        return [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    },
    async handleSetFavorite() {
      const vm = this
      try {
        let favStatus = vm.intent.is_favorite ? vm.intent.is_favorite : false

        const data = {
          pageId: vm.selectedBot.pageid,
          intentId: vm.intent.id,
          is_favorite: !favStatus
        }

        vm.$store.dispatch('loading')
        const response = await intentApi.putSetFavoriteIntent({ data: data })
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.$emit('onFetchAll')
        }
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.intent = newVal
      // this.showDetail = newVal.isShow
    },
    'intent.q_val': function (newVal, oldVal) {
      this.formatData(this.intent.q_val)
      this.showMultipleChannel =
        (this.intent.fb_val || this.intent.line_val || this.intent.ig_val) != null
    },
    'value.isShow': function (newVal) {
      // this.showDetail = newVal
    },
    intent: function (newVal) {
      this.$emit('onUpdate', newVal)
      // this.intent = Object.assign({},newVal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/intent-item.vue